<template>
  <div style="background-color:black;height:100%">
    <div fill-height fluid class="ma-0">
      <v-btn dark icon class="back-button mx-10" @click="confirmBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-row class="pa-8" justify="center">
        <h2 class="red--text">Add DELIVERIES / COLLECTIONS</h2>
      </v-row>
      <v-row class="fill-height" justify="center" align="start">
        <v-col cols="12" md="10" class="pa-0">
          <v-card elevation="0" class="add-delivery-card pa-4">
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-row>
                  <!-- First Row -->
                  <v-col cols="12" sm="3">
                    <v-text-field
                      v-model="delivery.deliveryNumber"
                      label="Delivery Number"
                      outlined
                      rounded
                      dense
                      prepend-inner-icon="mdi-package-variant-closed"
                      class="montserrat-input"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-select
                      v-model="delivery.method"
                      :items="methods"
                      label="Delivery Method"
                      outlined
                      rounded
                      dense
                      prepend-inner-icon="mdi-truck"
                      class="montserrat-input"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-select
                      v-model="delivery.type"
                      :items="filteredTypes"
                      label="Type"
                      outlined
                      rounded
                      dense
                      prepend-inner-icon="mdi-transfer"
                      class="montserrat-input"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="3">
  <v-text-field
    v-model="delivery.driverName"
    label="Driver Name"
    outlined
    rounded
    dense
    prepend-inner-icon="mdi-account"
    class="montserrat-input"
    :rules="[isInTransit ? rules.required : []]" 
  ></v-text-field>
</v-col>

                </v-row>

                <v-row>
                  <!-- Second Row -->
                  <v-col cols="12" sm="3">
                    <v-text-field
                      v-model="delivery.invoice"
                      label="Invoice Number (Optional)"
                      outlined
                      rounded
                      dense
                      prepend-inner-icon="mdi-numeric"
                      class="montserrat-input"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-text-field
                      v-model="delivery.poNumber"
                      label="PO Number (Optional)"
                      outlined
                      rounded
                      dense
                      prepend-inner-icon="mdi-numeric"
                      class="montserrat-input"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-autocomplete
                      v-model="delivery.location"
                      :items="combinedLocations"
                      label="Location (Suppliers & Customers)"
                      outlined
                      rounded
                      dense
                      item-text="name"
                      item-value="account"
                      prepend-inner-icon="mdi-map-marker"
                      class="montserrat-input"
                      :rules="[rules.required]"
                      :loading="loadingLocations"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-select
                      v-model="delivery.engineer"
                      :items="engineers"
                      label="Engineer"
                      outlined
                      rounded
                      dense
                      prepend-inner-icon="mdi-account"
                      class="montserrat-input"
                      :rules="[!isSalespersonSelected ? rules.required : []]"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- Third Row -->
                  <v-col cols="12" sm="3">
                    <v-select
                      v-model="delivery.salesperson"
                      :items="salespersons"
                      label="Salesperson"
                      outlined
                      rounded
                      dense
                      prepend-inner-icon="mdi-account"
                      class="montserrat-input"
                      :rules="[!isEngineerSelected ? rules.required : []]"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-select
                      v-model="delivery.urgency"
                      :items="urgencies"
                      label="Priority"
                      outlined
                      rounded
                      dense
                      prepend-inner-icon="mdi-alert-circle"
                      class="montserrat-input"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <!-- Updated Date Picker -->
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formattedDate"
                          label="Date"
                          outlined
                          rounded
                          dense
                          prepend-inner-icon="mdi-calendar"
                          class="montserrat-input"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="delivery.date"
                        no-title
                        :min="new Date().toISOString().substr(0, 10)"
                        :max="getMaxDate()"
                        @input="onDatePicked"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-text-field
                      v-model="delivery.time"
                      label="Time"
                      outlined
                      rounded
                      dense
                      prepend-inner-icon="mdi-clock"
                      class="montserrat-input"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-select
                      v-model="delivery.status"
                      :items="statuses"
                      label="Status"
                      outlined
                      rounded
                      dense
                      prepend-inner-icon="mdi-truck-delivery"
                      class="montserrat-input"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                
                </v-row>

                <!-- Reason Field -->
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="delivery.reason"
                      label="Reason for Delivery/Collection"
                      outlined
                      rounded
                      dense
                      prepend-inner-icon="mdi-comment-alert"
                      class="montserrat-input"
                      :rules="[reasonRequired ? rules.required : []]"
                    ></v-textarea>
                  </v-col>
                </v-row>

                <!-- Dynamic Delivery Items Section -->
                <v-row>
                  <h2 class="red--text mx-12" style="margin-bottom: 30px;">DELIVERY ITEMS</h2>
                </v-row>
                <div v-for="(item, index) in deliveryItems" :key="index">
                  <v-row>
                    <v-col cols="12" sm="2">
                      <v-text-field
                        v-model="item.qty"
                        label="QTY"
                        outlined
                        rounded
                        dense
                        prepend-inner-icon="mdi-numeric"
                        class="montserrat-input"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                      <v-text-field
                        v-model="item.code"
                        label="Code"
                        outlined
                        rounded
                        dense
                        prepend-inner-icon="mdi-numeric"
                        class="montserrat-input"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        v-model="item.description"
                        label="Description"
                        outlined
                        rounded
                        dense
                        prepend-inner-icon="mdi-numeric"
                        class="montserrat-input"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                      <v-text-field
                        v-model="item.refnum"
                        label="Reference Number"
                        outlined
                        rounded
                        dense
                        prepend-inner-icon="mdi-numeric"
                        class="montserrat-input"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" v-if="delivery.type === 'Both'">
                      <v-select
                        v-model="item.for"
                        :items="['Delivery', 'Collection']"
                        label="For"
                        outlined
                        rounded
                        dense
                        class="montserrat-input"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="1">
                      <v-btn icon @click="confirmRemoveDeliveryItem(index)" color="red">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>

                <!-- Add More Delivery Items -->
                <v-row justify="left" class="mt-3">
                  <v-btn
                    color="black"
                    outlined
                    dark
                    width="300px"
                    rounded
                    @click="confirmAddMoreDeliveryItems"
                  >
                    <v-icon left>mdi-plus-circle-outline</v-icon>Add More Delivery Items
                  </v-btn>
                </v-row>

                <!-- Save Button -->
                <v-row justify="center">
                  <v-btn dark rounded large width="300px" @click="confirmSubmit" class="montserrat-button my-3">
                    <v-icon left>mdi-briefcase-plus</v-icon>Save
                  </v-btn>
                </v-row>
              </v-form>
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="primary"
                size="70"
                class="my-4"
              ></v-progress-circular>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Confirmation Dialogs -->
    <v-dialog v-model="dialogSubmit" max-width="400px">
      <v-card>
        <v-card-title class="headline">Confirm Save</v-card-title>
        <v-card-text>Are you sure you want to save this delivery/collection?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark rounded dense width="150px" @click="submit">Save</v-btn>
          <v-btn color="red" dark rounded dense width="150px" @click="dialogSubmit = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddItem" max-width="400px">
      <v-card>
        <v-card-title class="headline">Confirm Add Item</v-card-title>
        <v-card-text>Are you sure you want to add this item?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark rounded dense width="150px" @click="addMoreDeliveryItems">Add</v-btn>
          <v-btn color="red" dark rounded dense width="150px" @click="dialogAddItem = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRemoveItem" max-width="400px">
      <v-card>
        <v-card-title class="headline">Confirm Remove Item</v-card-title>
        <v-card-text>Are you sure you want to remove this item?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark rounded dense width="150px" @click="removeDeliveryItemConfirmed">Remove</v-btn>
          <v-btn color="red" dark rounded dense width="150px" @click="dialogRemoveItem = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="4000" top color="green" dark>
      Delivery created successfully!
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialogBack" max-width="400px">
      <v-card>
        <v-card-title class="headline">Confirm Navigation</v-card-title>
        <v-card-text>Are you sure you want to go back without saving?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark rounded dense width="150px" @click="navigateBack">Yes</v-btn>
          <v-btn color="red" dark rounded dense width="150px" @click="dialogBack = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getFirestore, collection, addDoc, getDocs, query, orderBy, limit } from "firebase/firestore";
import { firebaseApp } from "@/firebaseConfig";

export default {
  data() {
    return {
      valid: false,
      snackbar: false,
      status: "",
      statuses: ["In Queue", "Booked", "In Transit", "Delayed", "Complete"], // New field for Status
      delivery: {
        deliveryNumber: 0, // Initialize as integer
        method: "",
        type: "",
        driverName: "",
        refNumber: "",
        invoice: "",
        poNumber: "",
        location: "",
        engineer: "",
        salesperson: "",
        reason: "",
        urgency: "",
        date: "", // This should be in 'YYYY-MM-DD' format
        time: "",
        status: "",
      },
      formattedDate: "", // Stores the formatted date for display
      deliveryItems: [
        {
          qty: "",
          code: "",
          description: "",
          refnum: "",
          for: "Delivery", // Default value for the 'for' field
        },
      ],
      customers: [],
      suppliers: [],
      methods: ["Driver", "Courier"],
      types: ["Collection", "Delivery", "Both"],
      urgencies: ["Urgent", "Medium", "Not Urgent"],
      engineers: [],
      salespersons: [],
      loading: false,
      menu: false,
      loadingLocations: false,
      dialogSubmit: false,
      dialogAddItem: false,
      dialogRemoveItem: false,
      dialogBack: false,
      rules: {
        required: (value) => !!value || "Required.",
        workHours: (value) => {
          if (!value) return true; // If no value is provided, don't apply the work hours rule
          const time = value.split(":");
          const hours = parseInt(time[0], 10);
          return (hours >= 9 && hours <= 17) || "Time must be within work hours (09:00 - 17:00).";
        },
        validTime: (value) => {
          if (!value) return true; // If no value is provided, don't apply the time format rule
          const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;
          return timePattern.test(value) || "Invalid time format (HH:MM)";
        },
      },
    };
  },
  computed: {
    isInTransit() {
    return this.delivery.status === "In Transit";
  },
    isEngineerSelected() {
      return !!this.delivery.engineer; // Returns true if engineer is selected
    },
    isSalespersonSelected() {
      return !!this.delivery.salesperson; // Returns true if salesperson is selected
    },
    filteredTypes() {
      return this.delivery.method === "Courier" ? ["Collection", "Delivery"] : this.types;
    },
    reasonRequired() {
      return this.delivery.method === "Courier";
    },
    combinedLocations() {
      const customerLocations = this.customers.map((c) => ({
        name: `${c.companyName} (Customer)`,
        // always fall back to the firestore doc ID if the account field is missing/blank
        account: c.customerAccount || c.docId
      }));

      const supplierLocations = this.suppliers.map((s) => ({
        name: `${s.supplierName} (Supplier)`,
        account: s.supplierAccount || s.docId
      }));

      return [...customerLocations, ...supplierLocations].sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
  },
  async created() {
    await this.fetchUsers();
    await this.generateDeliveryNumber();
    await this.fetchLocations();
  },
  methods: {
    async fetchLocations() {
      this.loadingLocations = true;
      try {
        await Promise.all([this.fetchCustomers(), this.fetchSuppliers()]);
      } finally {
        this.loadingLocations = false;
      }
    },
    async fetchCustomers() {
      try {
        const db = getFirestore(firebaseApp);
        const customersCollection = collection(db, "customers");
        const customersSnapshot = await getDocs(customersCollection);
        this.customers = customersSnapshot.docs.map((doc) => ({
          docId: doc.id,
          companyName: doc.data()["Company Name"] || "",
          contactPerson: doc.data()["Contact Person"] || "",
          customerAccount: doc.data()["Customer Account"] || "",
        }));
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    },
    async fetchSuppliers() {
      try {
        const db = getFirestore(firebaseApp);
        const suppliersCollection = collection(db, "suppliers");
        const suppliersSnapshot = await getDocs(suppliersCollection);
        this.suppliers = suppliersSnapshot.docs.map((doc) => ({
          docId: doc.id,
          supplierName: doc.data()["Supplier Name"] || "",
          contactPerson: doc.data()["Contact Person"] || "",
          supplierAccount: doc.data()["Supplier Account"] || "",
        }));
      } catch (error) {
        console.error("Error fetching suppliers:", error);
      }
    },
    async generateDeliveryNumber() {
      const db = getFirestore(firebaseApp);
      const deliveriesCollection = collection(db, "deliveries");

      try {
        // Query to get the last delivery by descending order of deliveryNumber
        const q = query(deliveriesCollection, orderBy("deliveryNumber", "desc"), limit(1));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          this.delivery.deliveryNumber = 1; // Start with 1 if no deliveries exist
        } else {
          // Fetch the last delivery document and increment the delivery number by 1
          const lastDelivery = querySnapshot.docs[0].data();
          this.delivery.deliveryNumber = parseInt(lastDelivery.deliveryNumber, 10) + 1;
        }
      } catch (error) {
        console.error("Error generating delivery number: ", error);
        this.delivery.deliveryNumber = 1; // Fallback in case of error
      }
    },
    async fetchUsers() {
      const db = getFirestore(firebaseApp);
      const usersSnapshot = await getDocs(collection(db, "users"));
      const usersData = usersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      this.engineers = usersData
        .filter((user) => user.role === "Engineer")
        .map((user) => user.fullName)
        .sort();

      this.salespersons = usersData
        .filter((user) => user.role === "Salesperson")
        .map((user) => user.fullName)
        .sort();
    },
    confirmAddMoreDeliveryItems() {
      this.dialogAddItem = true;
    },
    addMoreDeliveryItems() {
      this.deliveryItems.push({
        qty: "",
        code: "",
        description: "",
        refnum: "",
        for: "Delivery", // Default value
      });
      this.dialogAddItem = false;
    },
    confirmRemoveDeliveryItem(index) {
      this.currentItemIndex = index;
      this.dialogRemoveItem = true;
    },
    removeDeliveryItemConfirmed() {
      this.deliveryItems.splice(this.currentItemIndex, 1);
      this.dialogRemoveItem = false;
    },
    confirmSubmit() {
      this.dialogSubmit = true;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const db = getFirestore(firebaseApp);

        try {
          // Create a payload object to ensure all fields are included
          const deliveryData = {
            deliveryNumber: this.delivery.deliveryNumber,
            method: this.delivery.method,
            type: this.delivery.type,
          
            invoice: this.delivery.invoice || "", // Optional field
            poNumber: this.delivery.poNumber || "", // Optional field
            location: this.delivery.location,
            engineer: this.delivery.engineer,
            salesperson: this.delivery.salesperson,
            reason: this.delivery.reason,
            urgency: this.delivery.urgency,
            date: this.delivery.date, // Use delivery.date
            time: this.delivery.time,
            status: this.delivery.status, // Include new status field
            driverName: this.delivery.driverName,
            deliveryItems: this.deliveryItems, // Include delivery items array
          };

          // Log the delivery data for debugging
          console.log("Submitting delivery data:", deliveryData);

          // Store the data in Firebase
          await addDoc(collection(db, "deliveries"), deliveryData);

          // Show success toast and route to /functions
          this.dialogSubmit = false;
          this.snackbar = true; // Show success toast
          this.$router.push("/functions");
        } catch (error) {
          console.error("Error creating delivery/collection: ", error);
        } finally {
          this.loading = false;
        }
      }
    },
    confirmBack() {
      this.dialogBack = true;
    },
    navigateBack() {
      this.dialogBack = false;
      this.$router.go(-1);
    },
    getMaxDate() {
      const today = new Date();
      const fiveWeeksFromToday = new Date();
      fiveWeeksFromToday.setDate(today.getDate() + 35); // 5 weeks = 35 days
      return fiveWeeksFromToday.toISOString().substr(0, 10);
    },
    onDatePicked(val) {
      this.menu = false;
      this.delivery.date = val; // val is in 'YYYY-MM-DD' format
      this.updateFormattedDate();
    },
    updateFormattedDate() {
      if (this.delivery.date) {
        const date = new Date(this.delivery.date);
        this.formattedDate = date.toLocaleDateString(); // Format the date for display
      } else {
        this.formattedDate = "";
      }
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");

body,
div,
span,
v-card-title,
v-card-text,
v-row,
v-col,
v-card,
v-file-input {
  font-family: "Montserrat", sans-serif;
}

.add-delivery-card {
  box-shadow: 10px 10px 20px #1b1c1e, -10px -10px 20px #c4242b;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 20px;
  width: 100%;
  padding: 20px;
  transition: all 0.3s ease-in-out;
}

.montserrat-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}

.montserrat-input {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
}

/* Make inputs smaller */
.small-input input,
.small-input .v-label,
.small-input .v-input__control {
  font-size: 12px !important; /* Reduce text size */
  height: 36px !important; /* Reduce field height */
}

.custom-col .v-input {
  margin-bottom: 12px; /* Reduce vertical spacing */
}

.montserrat-button {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}

.back-button {
  color: white;
  border-radius: 50%;
  position: absolute;
  top: 16px;
  left: 16px;
  transition: transform 0.3s ease-in-out;
}

.back-button:hover {
  transform: scale(1.1);
}

.back-button .v-icon {
  color: white;
}
</style>